
import { ButtonHTMLAttributes, ReactNode } from 'react';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  children: ReactNode;
}

export default function Button({ 
  variant = 'primary', 
  size = 'md', 
  children, 
  className = '', 
  ...props 
}: ButtonProps) {
  const baseClasses = 'inline-flex items-center justify-center font-light transition-all duration-300 whitespace-nowrap cursor-pointer tracking-wide';
  
  const variantClasses = {
    primary: 'bg-gradient-to-r from-pink-400 via-blue-400 to-teal-400 text-white hover:from-pink-500 hover:via-blue-500 hover:to-teal-500 shadow-lg hover:shadow-xl',
    secondary: 'bg-white text-gray-700 hover:bg-gray-50 shadow-md hover:shadow-lg border border-gray-200',
    outline: 'border-2 border-gray-300 text-gray-700 hover:border-pink-400 hover:text-pink-500 bg-white hover:bg-pink-50',
    ghost: 'text-gray-600 hover:text-gray-800 hover:bg-gray-50'
  };
  
  const sizeClasses = {
    sm: 'px-6 py-2 text-sm rounded-full',
    md: 'px-8 py-3 text-base rounded-full',
    lg: 'px-10 py-4 text-lg rounded-full'
  };
  
  return (
    <button 
      className={`${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}
